



























































import { Component, Mixins} from 'vue-property-decorator';
import {ContractFiles, GetContractFilesRequest} from 'ncp-api-supporter';
import VueI18n from 'vue-i18n';
import LocaleMessage = VueI18n.LocaleMessage;
import FileInputMixin from '@/components/common/input/FileInputMixin.vue';

@Component
export default class ContractDown extends Mixins(FileInputMixin) {
  private domesticDocuments: boolean = true;
  private contractNo: number = 0;
  private contracts: ContractFiles[] = [];
  private _contracts = [...this.contracts];
  private contractStatus = this.$route.query.contractStatus;
  private mallNo = this.$route.query.mallNo as string;

  private async mounted() {
    await this.getContractsFiles();
  }
  private get hasAttachedFiles() {
    return this.contracts.some(doc => doc.originalName) ;
  }
  //NOTE: return 을 string 으로 받음.
  private get isDomestic() {
    return this.contracts.length > 0 ? 'true' : 'false';
  }
  private drawFileButtonName(isFileName: boolean) {
    return isFileName ? this.$t('PARTNER_POPUP_UPDATE_CONTRACT_FILE') : this.$t('PARTNER_POPUP_ADD_CONTRACT_FILE');
  }
  private validateFile(file): boolean | FormData {
    const fileElements = file.name.split('.');
    const fileExe = fileElements[fileElements.length - 1];
    //NOTE 확장자 확인필요 : 프로 쇼핑몰 수정 계약서류랑 파트너 등록시 계약서류랑 가능한 확장자가 상이함
    const exes = ['doc', 'docx', 'xls', 'xlsx', 'jpg', 'jpeg', 'gif', 'png', 'pdf'];
    if (!exes.includes(fileExe)) {
      alert(this.$t('PARTNER_POPUP_ALERT_INCORRECT_FILE'));
      return false;
    }
    if (!this.validateFileSize(file)) {
      alert(this.$t('PRODUCT.ADD.IMAGE_MAX_SIZE'));
      return false;
    }
    return true;
  }
  private async uploadContractFile(e, contract, originTitle, displayOrder) {
    const [file] = e.target.files;
    if (!this.validateFile(file)) return;
    contract.originalName ? this.updateContractFile(file, contract, originTitle) : this.addContractFile(file, contract, displayOrder);
  }
  private async updateContractFile(file, contract, originTitle) {
    if (!confirm(this.$t('PARTNER_POPUP_ALERT_UPDATE_CONTRACT_FILE') as string)) return;
    const formData = new FormData();
    formData.append('file', file);
    const { uploadedName, title } = contract;
    const requestParams = {
      contractNo: this.contractNo,
      uploadedName,
      title: title ?? originTitle,
    };
    try {
      await this.$api.putContractsFiles({ params: requestParams, data: formData });
      alert(this.$t('PARTNER_POPUP_ALERT_UPDATE_CONTRACT_FILE_COMPLETE') as string);
      this.getContractsFiles();
    } catch (e) {
      alert(e.data.message);
    }
  }
  private async addContractFile(file, contract, displayOrder) {
    const data = new FormData();
    data.append('file', file);
    data.append('mallNo', this.mallNo);
    data.append('domestic', this.isDomestic);
    data.append('displayOrder', displayOrder);
    data.append('title', contract.title);
    try {
      await this.$api.postStorageContracts({ params: { contractNo: this.contractNo }, data });
      this.getContractsFiles();
    } catch (e) {
      alert(e.data.message);
    }
  }


  private async getContractsFiles() {
    this.contractNo = Number(this.$route.query.contractNo);
    const getContractFilesRequest: GetContractFilesRequest = {
      params: {
        contractNo: this.contractNo
      }
    };
    const {
      data: {domesticDocuments, globalDocuments}
    } = await this.$api.getContractsFiles(getContractFilesRequest);

    this.setContracts(domesticDocuments, globalDocuments);
  }

  private setContracts(domesticDocuments, globalDocuments) {
    if (domesticDocuments.length > 0) {
      this.contracts = domesticDocuments;
      this.domesticDocuments = true;
    } else {
      this.contracts = globalDocuments;
      this.domesticDocuments = false;
    }
    this._contracts = [...this.contracts];
  }

  private getContractsTitle(displayOrder: number): string {
    const domesticDocuments: LocaleMessage = {
      0: this.$t('PARTNER_POPUP_DOMESTIC_DOCUMENT_0'),
      1: this.$t('PARTNER_POPUP_DOMESTIC_DOCUMENT_1'),
      2: this.$t('PARTNER_POPUP_DOMESTIC_DOCUMENT_2')
    };
    const globalDocuments: LocaleMessage = {
      0: this.$t('PARTNER_POPUP_GLOBAL_DOCUMENT_0')
    };
    return this.domesticDocuments ? this.getFileName(domesticDocuments, displayOrder) : this.getFileName(globalDocuments, displayOrder);
  }

  private getFileName(documents, displayOrder): string {
    let documentTitle: string;

    if (documents.hasOwnProperty(displayOrder)) {
      documentTitle = documents[displayOrder];
    } else {
      const documentsIndex = displayOrder - Object.keys(documents).length + 1;
      documentTitle = `${this.$t('PARTNER_POPUP_DOCUMENT')} ${documentsIndex}`;
    }
    return documentTitle;
  }

  private toDownloadAll: boolean = false;

  private async getStorage(contract) {
		await this.getStorageContracts(contract.uploadedName, contract.originalName)
	  this.toDownloadAll === true && this.getAllStorage();
  }

  private getAllStorage() {
    if (!this._contracts.length) {
      this.toDownloadAll = false;
      this._contracts = [...this.contracts];
    } else {
      const contract = this._contracts.shift();
      this.toDownloadAll = true;
      this.getStorage(contract);
    }
  }

  private getStorageContracts(fileName, saveAs) {
    if (!fileName) return;
	  this.$api.getStorageContracts({
		  params: {
		  	fileName,
			  saveAs
		  }
	  }).then((ret: any) => {
		  const myBlob = new Blob([ret.data], {type: 'blob'});
		  const qrUrl = window.URL.createObjectURL(myBlob);
		  const a = document.createElement('a');
		  const event = new MouseEvent('click');
		  a.download = saveAs;
		  a.href = qrUrl;
		  a.dispatchEvent(event);
		  window.URL.revokeObjectURL(qrUrl);
	  })
  }

  private close(): void {
    window.close();
  }
}
